import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import NotificationChannelItem from './NotificationChannelItem';

import { getAppChannelDetails } from '../utils/app';
import { isChannelLinked, getDisplayName } from '../utils/user';

export class SettingsComponent extends Component {
    static propTypes = {
        appChannels: PropTypes.array.isRequired,
        integrationOrder: PropTypes.array,
        user: PropTypes.object.isRequired,
        notificationSettingsChannelsTitleText: PropTypes.string.isRequired,
        notificationSettingsChannelsDescriptionText: PropTypes.string.isRequired,
    };

    render() {
        const {
            appChannels,
            integrationOrder,
            user,
            notificationSettingsChannelsTitleText,
            notificationSettingsChannelsDescriptionText,
        } = this.props;

        let channels = getAppChannelDetails(appChannels, integrationOrder);
        channels.sort(
            ({ channel: channelA, details: { order: orderA } }, { channel: channelB, details: { order: orderB } }) => {
                const linkedA = isChannelLinked(user.clients, channelA.type);
                const linkedB = isChannelLinked(user.clients, channelB.type);

                if (linkedA && linkedB) {
                    return orderA - orderB;
                }

                if (linkedA) {
                    return -1;
                }

                if (linkedB) {
                    return 1;
                }

                return orderA - orderB;
            },
        );

        channels = channels.map(({ channel, details }) => {
            return (
                <NotificationChannelItem
                    key={channel.type}
                    id={channel.category}
                    {...details}
                    displayName={getDisplayName(user.clients, channel.type)}
                    linked={isChannelLinked(user.clients, channel.type)}
                    hasURL={!!details.getURL(channel)}
                />
            );
        });

        return (
            <div className="settings">
                <div className="content-wrapper">
                    <div className="settings-wrapper">
                        <p className="settings-header">{notificationSettingsChannelsTitleText}</p>
                        <p className="settings-description">{notificationSettingsChannelsDescriptionText}</p>
                        <div className="channels">{channels}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ config, user, ui }) => {
        return {
            appChannels: config.integrations,
            integrationOrder: config.integrationOrder,
            notificationSettingsChannelsTitleText: ui.text.notificationSettingsChannelsTitle,
            notificationSettingsChannelsDescriptionText: ui.text.notificationSettingsChannelsDescription,
            user,
        };
    },
    null,
    null,
    { forwardRef: true },
)(SettingsComponent);
